import WithLoadable from 'components/WithLoadable';

export default WithLoadable(() => import(/* webpackChunkName: "landing-page" */ './index'));
